/* ==========================================================================
   BLIT scroll behaviour
   1. Reveal — elements marked [data-blit-reveal] fade + rise into place
      the first time they enter the viewport (stagger via --d).
   2. Parallax — the hero image drifts slower than the page.
   Both respect prefers-reduced-motion.
   ========================================================================== */
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. reveal on scroll ---------- */
  function initReveal() {
    var targets = document.querySelectorAll('[data-blit-reveal]');
    if (!targets.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      for (var i = 0; i < targets.length; i++) targets[i].classList.add('is-in');
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    for (var j = 0; j < targets.length; j++) obs.observe(targets[j]);
  }

  /* ---------- 2. hero parallax ---------- */
  function initParallax() {
    if (reduced) return;

    var layers = document.querySelectorAll('.blit-hero__media, [data-blit-parallax]');
    if (!layers.length) return;

    var ticking = false;

    function frame() {
      ticking = false;
      for (var i = 0; i < layers.length; i++) {
        var el = layers[i];
        var host = el.closest('.blit-hero') || el.parentElement;
        if (!host) continue;

        var rect = host.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) continue;

        var progress = -rect.top / (rect.height || 1);
        var shift = Math.max(-1, Math.min(1, progress)) * 60;
        el.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0) scale(1.08)';
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(frame);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    frame();
  }

  function init() {
    initReveal();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
